export default __webpack_public_path__ + "static/media/arrow_left_red.b2284350.svg";